<app-modal-wrapper
  title="Edit Profile"
  [isDirty]="editForm?.dirty ?? false"
  [formValid]="editForm?.valid ?? false"
  [showSaveButton]="true"
  [saveLoading]="submitting"
  keepEditingLabel="Keep editing"
  (save)="saveRecord()"
  (closeRequest)="ref.close()"
>
  <form #editForm="ngForm" class="flex flex-col gap-5 pt-2">
    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Name <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        type="text"
        name="displayName"
        [(ngModel)]="model.displayName"
        class="w-full text-sm"
        placeholder="How you want to be called"
        required
        autofocus
        autocomplete="off"
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        E-mail
      </label>
      <input
        pInputText
        type="text"
        name="email"
        [ngModel]="model.email"
        class="w-full text-sm !bg-gray-100 opacity-80 cursor-not-allowed"
        [disabled]="true"
      />
    </div>
  </form>
</app-modal-wrapper>
